import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const BASE_URL = "https://www.donghungvienbakery.com";

/**
 * Dynamically sets the canonical URL for every route so Google
 * knows the authoritative URL for each page (not just the homepage).
 * Place this inside <Router> in App.js — it runs on every navigation.
 */
export default function CanonicalTag() {
  const { pathname } = useLocation();

  // Root keeps trailing slash; all other paths strip it for consistency
  const canonical =
    pathname === "/"
      ? `${BASE_URL}/`
      : `${BASE_URL}${pathname.replace(/\/$/, "")}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
    </Helmet>
  );
}
